import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function SaveLogsForAmazonProductListingService(token, data) {
    return axios.post(`${CURRENT_API_URL}/AmazonProductListing/saveLogsForAmazonProductListing`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        return res.data;
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching data. Please try again later.");
        return null;
    });
}

export default SaveLogsForAmazonProductListingService;